import React from 'react'
import WorkPlaces from '../../components/User/Contact/Workplaces'
import MinemoContact from '../../components/User/Home/Minemocontact'
import TeamContacts from '../../components/User/Contact/Teamcontacts'
import SimpleBanner from '../../components/common/SimpleBanner'
import MapSection from '../../components/User/Contact/MapSection'

const Contact = () => {
  return (
    <div>
      <SimpleBanner title="Contact Us" subHeading="Home > Contact Us" />
      {/* <WorkPlaces/> */}
      <MapSection/>
      <MinemoContact/>
      {/* <TeamContacts/> */}
    </div>
  )
}

export default Contact
